import React from "react";

import { useGetApplicationQuery } from "EmployeeApplication/api";
import { LongTermDisabilityPage } from "EmployeeCoverage/Components/LongTermDisability";
import { Link } from "react-router-dom";
import BasicLoading from "ZeroRuby/BasicLoading";

import BodyText from "Cobalt/BodyText";
import { CardSection } from "Cobalt/Card";
import { RoutedBackButton } from "Common/forms/buttons";

import MissingZipCode from "./components/MissingZipCode";
import Page from "./Page";

const NoCoverageOffered = () => (
  <CardSection>
    <BodyText size="large" agent>
      Your company does not offer long term disability insurance at this time.
    </BodyText>
  </CardSection>
);

const useData = () => {
  const { isLoading: isLoadingApplication, data: { employeePolicy: { employeeForm: { zipCode } = {} } = {}, availablePlans = [] } = {} } =
    useGetApplicationQuery();

  return {
    isLoadingApplication,
    offeringLongTermDisability: availablePlans.includes("long_term_disability"),
    missingZipCode: !zipCode,
  };
};

const PageContent = () => {
  const { isLoadingApplication, missingZipCode, offeringLongTermDisability } = useData();

  if (isLoadingApplication) {
    return (
      <CardSection>
        <BasicLoading />
      </CardSection>
    );
  }
  if (missingZipCode) {
    return (
      <CardSection>
        <MissingZipCode />
      </CardSection>
    );
  }
  if (!offeringLongTermDisability) {
    return (
      <CardSection>
        <NoCoverageOffered />
      </CardSection>
    );
  }
  return <LongTermDisabilityPage />;
};

const ChooseLongTermDisabilityCoveragePage = ({ backLink, onClickBack }) => (
  <Page title="Choose Long Term Disability Coverage">
    <PageContent />
    <CardSection>
      <RoutedBackButton href={backLink} onClick={onClickBack} />
    </CardSection>
  </Page>
);

export default ChooseLongTermDisabilityCoveragePage;
